//Created 2024-04-09 for RefreshToken https://www.bezkoder.com/vue-3-refresh-token/

import axiosInstance from "./api";
import TokenService from "./token.service";
import router from '@/router';
//import EventBus from "./common/EventBus"; //To call EventBus.logout if refreshToken is expired 2024-04-22

const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      //console.log(token);
      if (token) {
        // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
        config.headers["x-access-token"] = token; // for Node.js Express back-end
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      if (originalConfig?.url !== "/auth/signin" && err.response) {
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          console.warn("401 from API request, attempting token refresh:", originalConfig.url);

          try {
            const refreshToken = TokenService.getLocalRefreshToken();

            if (!refreshToken) {
              console.warn("No refresh token available; logging out user.");
              store.dispatch("auth/logout");
              router.push('/tunes');
              return Promise.reject(err);
            }

            const rs = await axiosInstance.post("/auth/refreshtoken", {
              refreshToken,
            });

            const { accessToken } = rs.data;

            store.dispatch('auth/refreshToken', accessToken);
            TokenService.updateLocalAccessToken(accessToken);

            return axiosInstance(originalConfig);
          } catch (_error) {
            console.warn("Token refresh failed; logging out user.", {
              url: originalConfig?.url,
              status: _error?.response?.status,
              message: _error?.response?.data?.message,
            });
            store.dispatch("auth/logout");
            router.push('/tunes');
            return Promise.reject(_error);
          }
        }
        else if (err.response.status === 403) {
          try {
            console.warn("403 from API request; logging out user.", originalConfig?.url);
            store.dispatch("auth/logout");
            router.push('/tunes');
          }
          catch(_error) {
            return Promise.reject(_error);  
          }   
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;